import * as React from "react";
import { SVGProps, memo } from "react";

const SvgHelp = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10.75 13.29a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" fill="#637182" />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-1.5 0a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Z"
      fill="#637182"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.507 6.094c.575.4.992 1.026 1.113 1.85.17 1.156-.207 1.502-.925 2.256-.337.355-.899.732-.899 1.172 0 .866-1.58.789-1.58 0 0-.98.644-1.215 1.074-1.689l.095-.105c.577-.64.81-1.005.75-1.417-.06-.415-.251-.673-.484-.835a1.533 1.533 0 0 0-.94-.245c-.422.02-.744.22-.949.48-.257.324-.412.69-1.008.69-.483 0-.688-.696-.506-1.17.422-1.099 1.342-1.45 2.393-1.499.631-.03 1.306.123 1.866.512Z"
      fill="#637182"
    />
  </svg>
);

const Memo = memo(SvgHelp);

export default Memo;
